import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import CustomParagraphComponent from "./Facilities/CustomParagraphComponent";
import GetInTouchFooter from "./GetInTouchFooter";
import axiosStrapiInstance, { baseUrl } from "../axiosStrapi";
import { toast } from "react-toastify";
import Loader from "./custom/Loader";
import CustomHeading from "./custom/CustomHeading";
import CustomContent from "./custom/CustomContent";
import { headerImages } from "../utils/constants";
import { Helmet } from "react-helmet";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getEvents(e) {
    try {
      setLoading(true);
      const response = await axiosStrapiInstance.get(
        "/api/page-contents?filters[pageType][$eq]=Events&populate=*&sort=pageTypeId:asc"
      );
      const result = response?.data?.data?.map((item) => ({
        ...item,
        images: item?.images?.map((item) => `${item?.url}`),
      }));
      setEvents(result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
    }
  }

  useEffect(() => {
    getEvents();
    const timer = setTimeout(() => {
      window.scrollTo(0, 1);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div>
      <Helmet>
        <title>
          Events at Mother's Pride - Celebrating Childhood & Learning
        </title>
        <meta
          name="description"
          content="Stay updated on the latest events at Mother's Pride where children learn, perform, and grow through joyful and engaging experiences."
        />
        <meta
          name="keywords"
          content="preschool activities, creative learning, kids development, playful learning, activity-based learning"
        />
        <link
          rel="canonical"
          href="https://www.motherspridepreschool.com/events" />
      </Helmet>
      <div>
        <div>
          <img
            src={
              window.innerWidth < 450
                ? window.innerWidth < 800
                  ? headerImages.tabEventsHeaderImg
                  : headerImages.mobileEventsHeaderImg
                : headerImages.eventsHeaderImg
            }
            alt="events"
            className="overflow-x-hidden w-[100vw] sm:h-[300px] lg:h-[420px] "
          />
        </div>
        <div className="px-[4%] 2xl:px-[6%] flex flex-col gap-10 ">
          {/* main img */}

          <div className="flex flex-col gap-3 sm:mt-[60px] mt-5">
            <div className="flex w-full flex-row items-end lg:mt-0 mt-5 gap-1">
              <CustomHeading
                text={"Events at mother"}
                spanText={"'"}
                spanTextColor="#383838"
                thirdTextColor="#383838"
                secondFontStyle="font-Lato"
                thirdText={"s Pride"}
                textSize="58px"
                heartPosition="absolute"
                textColor="#383838"
                showHeart={window.innerWidth > 1300 && true}
                heartMarginLeft={window.innerWidth < 450 ? "2%" : "50%"}
                heartHeight="40px"
                heartWidth="40px"
                smTextSize="32px"
              />
              <div className="inline">
                <CustomContent
                  textColor="#d31c4f"
                  text={"//PreSchool"}
                  textSize="42px"
                  smTextSize="20px"
                  leading="52px"
                  marginTop={window.innerWidth < 450 ? "-32px" : "0"}
                />
              </div>
            </div>
          </div>

          {/* all the divs */}
          <div className="flex flex-col gap-[50px] ">
            {loading ? (
              <Loader />
            ) : (
              events?.map((item, index) => (
                <CustomParagraphComponent
                  key={index}
                  heading={item?.heading}
                  content={item?.content}
                  images={item?.images}
                  subHeading={item?.subHeading}
                />
              ))
            )}
          </div>

          <GetInTouchFooter marginX={"0%"} />
          {/* Footer */}
          <div>
            <Footer marginX={"0%"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Events;
